import React, { useState, useEffect } from "react";
import "./SideBar.css";
import Editor from "../../Utility/textEditor/editor";
import { toast } from "react-toastify";
import getUsernameFromSession from "../../Utility/gettingInformation/getUsernameFromSession";

import authHeader from "../../headerTokenUtility/auth.header";
import { NavLink, Outlet } from "react-router-dom";
import {
  Home,
  Phone,
  HelpCircle,
  FileText,
  Calendar,
  User,
  CreditCard,
  Settings,
  LogOut,
} from "lucide-react";
import url from "../../Utility/URL/url";
import axios from "axios";

function SideBar() {
  const mainMenus = [
    { text: "Home", icon: Home, path: "/dashboard/Home" },
    { text: "Calls", icon: Phone, path: "/dashboard/Calls" },
    { text: "Queries", icon: HelpCircle, path: "/dashboard/Queries" },
    { text: "Services", icon: FileText, path: "/dashboard/Services" },
    { text: "Availability", icon: Calendar, path: "/dashboard/Availability" },
  ];

  const accountMenus = [
    { text: "Profile", icon: User, path: "/dashboard/Profile" },
    { text: "Payments", icon: CreditCard, path: "/dashboard/Payments" },
    { text: "Settings", icon: Settings, path: "/dashboard/Settings" },
    { text: "Logout", icon: LogOut, path: "/signin" }, // example logout route
  ];
  const username = getUsernameFromSession();
  const [profileDetails, setProfileDetails] = useState(null);
  const [originalProfileDetails, setOriginalProfileDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  // ✅ Fetch Profile Details
  const [imgLoaded, setImgLoaded] = useState(false);
  useEffect(() => {
    async function getProfileDetails() {
      try {
        const response = await axios.post(
          `${url.GET_PROFILE_DETAILS}?username=${username}`,
          {}, // body is empty
          { headers: authHeader() }
        );

        setProfileDetails(response.data);
        setOriginalProfileDetails(response.data);
      } catch (error) {
        console.error(error);
        toast.warning(
          "Technical Error while fetching the profile Details.. Please retry again!",
          { position: toast.POSITION.TOP_RIGHT }
        );
      } finally {
        setLoading(false);
      }
    }

    getProfileDetails();

    return () => {
      // console.log("Profile component unmounted");
    };
  }, [username]);

  const renderMenuItem = ({ text, icon: Icon, path }) => (
    <li className="list" key={text}>
      <NavLink
        to={path}
        className={({ isActive }) =>
          `nav-link ${
            isActive
              ? "active-dash text-purple-600 font-semibold"
              : "text-gray-500"
          }`
        }
      >
        <Icon className="w-5 h-5 mr-2 transition-colors duration-200" />
        <span className="link">{text}</span>
      </NavLink>
    </li>
  );

  return (
    <div className="dashboard-container">
      <div className="sidebar">
        
         <div className="">
          <div className="logo">
            {/* <i className="bx bx-menu menu-icon"></i> */}
            {/* <span className="logo-name">Advising Buddy</span> */}

            <img
              src={
                profileDetails?.profilePic ||
                "https://w0.peakpx.com/wallpaper/979/89/HD-wallpaper-purple-smile-design-eye-smily-profile-pic-face-thumbnail.jpg"
              }
              alt="Profile"
              style={{
                borderRadius: "50%",
                height: "46px",
                width: "46px",
                objectFit: "cover",
                opacity: imgLoaded ? 1 : 0,
                transition: "opacity 0.3s ease-in-out",
              }}
              onLoad={() => setImgLoaded(true)}
              onError={() => {
                setImgLoaded(true);
                console.error("Failed to load profile image");
              }}
            />
            {!imgLoaded && (
              <div
                style={{
                  width: 46,
                  height: 46,
                  borderRadius: "50%",
                  backgroundColor: "#e5e7eb",
                }}
              />
            )}
          
          <div className="logo-content">
            <h5
              className="m-0"
              style={{
                fontWeight: "bold",
                fontSize: "18px",
                lineHeight: "24px",
              }}
            >
              {profileDetails ? profileDetails.fullName : ""}
            </h5>
            <p
              className="m-0"
              style={{
                fontSize: "14px",
                color: "#868080",
                lineHeight: "13px",
              }}
            >
              {profileDetails ? profileDetails.email : ""}
            </p>
          </div>
       
          <div
            style={{
              cursor: "pointer",
              rotate: "90deg",
              position: "absolute",
              right: "2px",
              top: "8px",
              zIndex: "999",
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="20"
              viewBox="0 0 24 24"
              width="20"
              fill="#999"
            >
              <circle cx="5" cy="12" r="2" />
              <circle cx="12" cy="12" r="2" />
              <circle cx="19" cy="12" r="2" />
            </svg>
          </div>
</div>
</div>
<div style={{position:"relative"}}>
<div className="sidebar-content">
          <ul className="lists">{mainMenus.map(renderMenuItem)}</ul>

          {/* Account section */}
          <div className="account-section mt-8">
            <h5
              className=" uppercase text-sm font-semibold m-0 mb-3"
              style={{
                color: "rgb(76 76 76)",
                fontSize: "22px",
                fontWeight: "700",
                borderBottom: "1px solid #e5e7eb",
                paddingBottom: "10px",
                paddingLeft: "30px",
              }}
            >
              Account
            </h5>
            <ul className="lists">{accountMenus.map(renderMenuItem)}</ul>
          </div>
        </div>
        </div>
      </div>
      <div className="right-panel">
        <Outlet />
      </div>
    </div>
  );
}

export default SideBar;
